import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";

import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import SellerLogin from "@/pages/SellerLogin";
import SellerDashboard from "@/pages/SellerDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Storefront from "@/pages/Storefront";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";

// Customer Pages
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerSignup from "@/pages/CustomerSignup";
import CustomerOrders from "@/pages/CustomerOrders";

// Context
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

function QueryRouteRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const requestedRoute = params.get("route");

    if (!requestedRoute || requestedRoute === location.pathname) return;

    navigate(requestedRoute, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <QueryRouteRedirect />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/seller/login" element={<SellerLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Customer Auth Routes */}
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="/customer/signup" element={<CustomerSignup />} />
            <Route path="/customer/orders" element={<CustomerOrders />} />
            
            {/* Seller Dashboard Routes */}
            <Route path="/seller/dashboard/*" element={<SellerDashboard />} />
            
            {/* Admin Dashboard Routes */}
            <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
            
            {/* Storefront Routes */}
            <Route path="/shop/:shopSlug" element={<Storefront />} />
            <Route path="/shop/:shopSlug/product/:productId" element={<ProductDetail />} />
            <Route path="/shop/:shopSlug/cart" element={<Cart />} />
            <Route path="/shop/:shopSlug/checkout" element={<Checkout />} />
            <Route path="/shop/:shopSlug/order-confirmation" element={<OrderConfirmation />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
